import { render, staticRenderFns } from "./LoadingAlertManual.vue?vue&type=template&id=4b5ffca4&"
import script from "./LoadingAlertManual.vue?vue&type=script&lang=js&"
export * from "./LoadingAlertManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports